import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  // Debug logging
  console.log('[Sentry] Initializing with DSN:', dsn ? 'DSN loaded ✓' : 'DSN missing ✗');

  if (!dsn) {
    console.warn('[Sentry] No DSN found. Sentry will not initialize.');
    return;
  }

  Sentry.init({
    dsn,

    // Enable debug mode in development
    debug: import.meta.env.DEV,

    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Privacy settings
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false, // Set to true to mask all inputs for privacy
      }),
    ],

    // Performance Monitoring - Track all page loads and navigations
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0, // 20% in production, 100% in dev

    // Session Replay - Capture user sessions
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 1.0, // 10% in production, 100% in dev
    replaysOnErrorSampleRate: 1.0, // Always capture when errors occur

    // Environment
    environment: import.meta.env.MODE,

    // Release tracking (for better debugging)
    release: import.meta.env.VITE_APP_VERSION || "development",

    // Filter out known noise
    ignoreErrors: [
      // Browser extensions
      "top.GLOBALS",
      "chrome-extension://",
      // Random network errors
      "Network request failed",
      "Failed to fetch",
    ],

    // Tag all events with useful metadata
    beforeSend(event) {
      // Add custom tags or filter events here if needed
      return event;
    },
  });

  console.log('[Sentry] Initialized successfully ✓');
  console.log('[Sentry] Environment:', import.meta.env.MODE);
  console.log('[Sentry] Performance tracking:', import.meta.env.DEV ? '100%' : '20%');
  console.log('[Sentry] Session replay:', import.meta.env.DEV ? '100%' : '10%');
}
